var map = {
	"./about-hero-2.svg": "9291",
	"./about-hero.svg": "a485",
	"./ai-agent-2.svg": "2a8d",
	"./ai-gateway.svg": "a1b3",
	"./ai-infrastructure.svg": "df8c",
	"./ai-service.svg": "972d",
	"./ai-tutor.svg": "3874",
	"./announcement.svg": "7565",
	"./api-community.svg": "7a67",
	"./api-consultancy-step.svg": "6ea5",
	"./api-consultancy.svg": "788e",
	"./api-economy-community.svg": "bb66",
	"./api-economy-connector-1.svg": "488a",
	"./api-economy-connector-2.svg": "2838",
	"./api-economy-education.svg": "f0ea",
	"./api-economy-hero-1.svg": "4112",
	"./api-economy-hero-2.svg": "faa8",
	"./api-economy-product.svg": "285c",
	"./api-economy-solution.svg": "850f",
	"./api-management-apis.svg": "5411",
	"./api-management-connectors-mobile.svg": "dc4e",
	"./api-management-platforms-mobile.svg": "62cd",
	"./api-management-platforms.svg": "0c44",
	"./api-management.svg": "5c7c",
	"./api-product.svg": "853a",
	"./automation.svg": "50d0",
	"./banking-open-api-hero.svg": "165d",
	"./benovelty-apis.svg": "e305",
	"./benovelty-open-banking-sdk.svg": "3b7d",
	"./bn-solutions-bg-sm.svg": "d2b4",
	"./bn-solutions-bg.svg": "4881",
	"./career-hero-1.svg": "74a5",
	"./career-hero-2.svg": "0340",
	"./careers-work-happily.svg": "4c96",
	"./communication.svg": "a2be",
	"./community-apply.svg": "dece",
	"./construction.svg": "6262",
	"./consultancy-overview-1.svg": "7824",
	"./consultancy-overview-2.svg": "c6a9",
	"./consultancy-overview-3.svg": "19d2",
	"./cyber-insurance/about.svg": "cc6b",
	"./cyber-insurance/coverage-1.svg": "13cf",
	"./cyber-insurance/coverage-2.svg": "7817",
	"./cyber-insurance/coverage-3.svg": "3edf",
	"./cyber-insurance/coverage-4.svg": "715a",
	"./cyber-insurance/coverage-5.svg": "c3f4",
	"./cyber-insurance/coverage-6.svg": "6dac",
	"./cyber-insurance/fiberapi.svg": "32de",
	"./d-biz.svg": "d752a",
	"./developer-apply.svg": "885b",
	"./event-resources.svg": "82c4",
	"./home-hero.svg": "f76c",
	"./industries/catering-banner-catalogue.svg": "1bb0",
	"./industries/communication-banner-catalogue.svg": "2515",
	"./industries/education-banner-catalogue.svg": "d383",
	"./industries/esport-banner-catalogue.svg": "d64b",
	"./industries/fs-banner-catalogue.svg": "1665",
	"./industries/health-banner-catalogue.svg": "8f3c",
	"./industries/insurance-banner-catalogue.svg": "b7ee",
	"./industries/tourism-banner-catalogue.svg": "ef82",
	"./kong-apiops.svg": "8de2",
	"./kong-building.svg": "247d",
	"./kong-environments.svg": "5ce4",
	"./kong-kubernetes.svg": "39f9",
	"./kong-plugins.svg": "bf08",
	"./oah-promote.svg": "34e16",
	"./partners-hero.svg": "9741",
	"./provider-apply.svg": "a18f",
	"./replay-video.svg": "478d",
	"./rocket-bg.svg": "1652",
	"./sdk-pilot-programme-hero.svg": "c448",
	"./send-bg.svg": "d078",
	"./send.svg": "44c0",
	"./subscribe-mobile.svg": "f758",
	"./team-business.svg": "f11d",
	"./team-delivery.svg": "2207",
	"./team-engineering.svg": "36b2",
	"./team-internship.svg": "9a5b",
	"./team-product.svg": "f348",
	"./team-ux.svg": "19e8",
	"./trust-hero.svg": "56a8",
	"./value-bededicated.svg": "2f12",
	"./value-beinnovative.svg": "31dc",
	"./value-beknowledgeable.svg": "2a44",
	"./value-betrusted.svg": "c05a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5da3";